import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "as-data" }
const _hoisted_2 = { class: "as-nav-tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "as-h2h as-scrolling as-scrolling__result-popup" }

import { ref, computed } from "vue";
import type { IMatch, IAnalysis } from "~src/interfaces";
import TabData from "~src/components/datas/TabData.vue";
import TabRateScore from "~src/components/datas/TabRateScore.vue";
import TabStatsHtFt from "~src/components/datas/TabStatsHtFt.vue";


const __default__ = {};

interface IProps {
  match: IMatch;
  data: IAnalysis;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Data',
  props: {
    match: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

const activeTab = ref("data");
const tabs = ref([
  {
    title: "DỮ LIỆU",
    key: "data",
  },
  {
    title: "tỷ lệ ghi/mất bàn thắng",
    key: "rate_score",
  },
  {
    title: "thống kê ht/ft",
    key: "stats_ht_ft",
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "as-nav-item",
          key: tab.key
        }, [
          _createElementVNode("a", {
            class: _normalizeClass(["as-nav-link", { active: activeTab.value === tab.key }]),
            onClick: ($event: any) => (activeTab.value = tab.key)
          }, _toDisplayString(tab.title), 11, _hoisted_3)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (activeTab.value === 'data')
        ? (_openBlock(), _createBlock(TabData, {
            key: 0,
            match: _ctx.match
          }, null, 8, ["match"]))
        : (activeTab.value === 'rate_score')
          ? (_openBlock(), _createBlock(TabRateScore, {
              key: 1,
              match: _ctx.match,
              data: _ctx.data
            }, null, 8, ["match", "data"]))
          : (activeTab.value === 'stats_ht_ft')
            ? (_openBlock(), _createBlock(TabStatsHtFt, {
                key: 2,
                match: _ctx.match
              }, null, 8, ["match"]))
            : _createCommentVNode("", true)
    ])
  ]))
}
}

})